import { render } from "./J2004.vue?vue&type=template&id=27cb0bb5"
import script from "./J2004.vue?vue&type=script&lang=js"
export * from "./J2004.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\afm.git - Kopie\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__